export default function PageHeader({ overline, title, subtitle, image }) {
  return (
    <section className="relative overflow-hidden bg-bone border-b border-sage/20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-28 pb-20 md:pt-36 md:pb-28 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
        <div className="md:col-span-7 animate-fade-up">
          {overline && <p className="overline mb-5">{overline}</p>}
          <h1 className="font-display text-5xl md:text-7xl font-semibold text-forest leading-[1.05] tracking-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-xl md:text-2xl text-ink/75 leading-relaxed max-w-2xl">
              {subtitle}
            </p>
          )}
        </div>
        {image && (
          <div className="md:col-span-5 relative animate-fade-up" style={{ animationDelay: "120ms" }}>
            <div className="aspect-[4/5] w-full overflow-hidden rounded-2xl border border-sage/30">
              <img src={image} alt="" className="w-full h-full object-cover" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
